// extracted by css-extract-rspack-plugin
export default {"base_button_override":"t4JKc","baseButtonOverride":"t4JKc","#":"B9OfM","mobile_override":"SArtU","mobileOverride":"SArtU","icon":"fjugY"};